import ConvertUtil from "utils/ConvertUtil.js";
import {getLocalizedUnit} from "utils/UnitLabelUtil.js";

export default class PaceUtil {
  static calculatePace(
    distanceInKM: number,
    durationInSeconds: number,
    distanceUnit: string,
    _unused: boolean = false,
    t: any = null
  ): string {
    const distance = ConvertUtil.convertDistance(distanceInKM, distanceUnit);

    const calculatedPace = Math.round(durationInSeconds / distance);
    let paceMinutes: any = Math.floor(calculatedPace / 60);
    let paceSeconds: any = calculatedPace - paceMinutes * 60;
    if (paceSeconds < 0) {
      paceSeconds = 60 + paceSeconds;
    }

    paceMinutes = isNaN(paceMinutes) || !isFinite(paceMinutes) ? "00" : paceMinutes;
    paceSeconds = isNaN(paceSeconds) || !isFinite(paceSeconds) ? "00" : paceSeconds;

    return `${paceMinutes.toString().padStart(2, "0")}:${paceSeconds.toString().padStart(2, "0")} /${getLocalizedUnit(distanceUnit, t)}`;
  }
}
